

import React, { memo } from 'react';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import cx from 'classnames';
import { COLOURS } from '../../../../ui-kit';
import './_submissions-graph.scss';

const { cyan: { jungleGreen: { monkey } } } = COLOURS;
const { grey: { athens: { bigFat } } } = COLOURS;

const SHADOW_DATA_SET_OPTIONS = {
  label: 'video shadow',
  fill: false,
  lineTension: 0.5,
  backgroundColor: bigFat,
  borderColor: bigFat,
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointRadius: 0,
  pointBackgroundColor: 'transparent',
  pointBorderColor: 'transparent'
};






function renderGraph(monthlySubmissions) {
  if (!monthlySubmissions.length) {return null;}

  const monthsData = [
  ...monthlySubmissions.map(({ date }, index) =>
  index === monthlySubmissions.length - 1 ?
  'This Month' :
  moment(date).format('MMM \'YY')
  ),
  moment().add(1, 'M').format('MMM \'YY')];


  const submissionsData = monthlySubmissions.map(({ submissions }) => submissions);
  const shadowData = submissionsData.map((data) => data - 2 < 2 ? 0 : data - 2);
  const pointColor = monthsData.
  map((_, index) => index !== monthsData.length - 2 ? COLOURS.cyan.aqua : monkey);
  const pointRadius = monthsData.map((_, index) => index !== monthsData.length - 2 ? 3 : 4);

  const data = {
    labels: monthsData,
    datasets: [
    {
      ...SHADOW_DATA_SET_OPTIONS,
      label: 'videos',
      backgroundColor: monkey,
      borderColor: monkey,
      pointBackgroundColor: pointColor,
      pointBorderColor: pointColor,
      pointRadius,
      pointHitRadius: 10,
      data: submissionsData
    },
    {
      ...SHADOW_DATA_SET_OPTIONS,
      data: shadowData
    }]

  };

  const options = {
    legend: {
      display: false
    },
    tooltips: {
      displayColors: false,
      footerAlign: 'center',
      xPadding: 15,
      yPadding: 15,
      callbacks: {
        title() {
          /* istanbul ignore next */
          return null;
        },
        label(tooltipItem) {
          // Don't render shadow dataset tooltip
          /* istanbul ignore next */
          if (tooltipItem.datasetIndex === 1) {return null;}

          /* istanbul ignore next */
          return `${tooltipItem.value} videos`;
        }
      }
    },
    layout: {
      padding: {
        top: 25,
        bottom: 10,
        left: 60,
        right: 60
      }
    },
    scales: {
      pointLabels: {
        fontStyle: 'bold'
      },
      xAxes: [{
        position: 'top',
        gridLines: {
          drawBorder: false,
          display: true
        },
        ticks: {
          padding: 25
        }
      }],
      yAxes: [{
        display: false
      }]
    }
  };

  return <Line data={data} options={options} height={240} width={1400} />;
}

function SubmissionsGraph({
  monthlySubmissions,
  isFullWidth
}) {
  return (
    <div
      className={cx('submissions-graph', {
        'submissions-graph--full-width': isFullWidth
      })}>

      <div className="submissions-graph__wrapper">
        <div className="submissions-graph__wrapper__container">
          {renderGraph(monthlySubmissions)}
        </div>
      </div>
    </div>);

}

export default memo(SubmissionsGraph);